// Pillar page content for all 6 (+ future) hudutfordringer
// Each pillar has: slug, hero, intro, recommended treatments, why-us angle, FAQ

export const PILLARS = {
  "akne-arr-uren-hud": {
    slug: "akne-arr-uren-hud",
    eyebrow: "Hudutfordring",
    h1: "Aknebehandling & arrbehandling i Oslo",
    metaTitle: "Aknebehandling Oslo | Hudklinikk for akne & aknearr – Medskinby",
    metaDescription:
      "Få bukt med akne, uren hud og aknearr. Skreddersydd klinisk behandlingsplan av erfarne hudterapeuter på Frogner i Oslo. Book konsultasjon.",
    lead:
      "Vi jobber målrettet med årsakene bak utbrudd – fra hormoner og mikrobiom til inflammasjon og kostholdsfaktorer. Behandlingen kombinerer flere teknikker for varig effekt på både aktiv akne og aknearr.",
    paragraphs: [
      "Akne er ikke én tilstand – det er en kombinasjon av talgproduksjon, betennelse, bakteriebalanse og hormonelle faktorer. Vår tilnærming starter alltid med en grundig kartlegging slik at protokollen treffer riktig.",
      "Vi jobber både med den aktive aknen og de spor den etterlater seg – aknearr, postinflammatorisk pigmentering og strukturskader i huden. Resultatene kommer gradvis, men de varer.",
    ],
    treatments: [
      { slug: "kjemisk-peeling", title: "Kjemisk peeling" },
      { slug: "dermapen", title: "Dermapen" },
      { slug: "microneedling", title: "Microneedling" },
      { slug: "mesoterapi", title: "Mesoterapi" },
      { slug: "polynukleotider", title: "Polynukleotider" },
      { slug: "led-lysbehandling", title: "LED-lysbehandling" },
      { slug: "dyprens", title: "Dyprens" },
      { slug: "hydrafacial", title: "Hydrafacial" },
      { slug: "subcision", title: "Subcision" },
    ],
    faq: [
      { q: "Hvor lang tid før jeg ser resultat?", a: "Synlig forbedring kommer ofte etter 3–6 behandlinger. Full effekt på aknearr tar 3–6 måneder." },
      { q: "Kan jeg gå på sminke etter behandling?", a: "På de fleste behandlinger anbefaler vi 24 timer uten sminke for å la huden roe seg." },
      { q: "Hva koster en aknebehandling?", a: "Pris avhenger av valgt protokoll. Du får et nøyaktig estimat i konsultasjonen." },
      { q: "Hvor mange behandlinger trenger jeg?", a: "De fleste pasienter starter med en kur på 4–6 behandlinger fordelt over noen måneder." },
    ],
  },
  "sensitiv-hud": {
    slug: "sensitiv-hud",
    eyebrow: "Hudutfordring",
    h1: "Behandling av sensitiv hud i Oslo",
    metaTitle: "Sensitiv hud Oslo | Skånsom klinisk behandling – Medskinby",
    metaDescription:
      "Skånsomme, kliniske protokoller for reaktiv hud som trenger ro, beskyttelse og styrking. Hudklinikk på Frogner, Oslo.",
    lead:
      "Skånsomme, kliniske protokoller for reaktiv hud som trenger ro, beskyttelse og styrking. Vi reduserer irritasjon, gjenoppbygger hudbarrieren og bygger huden tilbake til balanse.",
    paragraphs: [
      "Sensitiv hud krever en helt annen tilnærming enn robust hud. Feil produkter, for sterke peelinger eller upresise behandlinger kan forverre symptomene. Hos oss starter vi alltid med å roe ned før vi styrker.",
      "Vi bruker dokumenterte aktive ingredienser i lave konsentrasjoner og kombinerer dem med LED-lys og barriere-rettede protokoller. Trygt, presist og effektivt.",
    ],
    treatments: [
      { slug: "beroligende-ansiktsbehandling", title: "Beroligende ansiktsbehandling" },
      { slug: "led-lysbehandling", title: "LED-lysbehandling" },
      { slug: "kjemisk-peeling", title: "Skreddersydd peeling" },
      { slug: "mesoterapi", title: "Mesoterapi for sensitiv hud" },
      { slug: "hydrafacial-sensitive", title: "Hydrafacial Sensitive" },
      { slug: "hudbarriere", title: "Hudbarrierestyrkende behandling" },
    ],
    faq: [
      { q: "Kan jeg ta peeling med sensitiv hud?", a: "Ja – men i lav konsentrasjon og bare etter at huden er stabilisert." },
      { q: "Hvor lang tid tar det å roe ned huden?", a: "Mange opplever betydelig ro etter 1–3 behandlinger." },
    ],
  },
  "rosacea-inflammasjon": {
    slug: "rosacea-inflammasjon",
    eyebrow: "Hudutfordring",
    h1: "Rosacea-behandling i Oslo",
    metaTitle: "Rosacea-behandling Oslo | Kliniske protokoller – Medskinby",
    metaDescription:
      "Roe ned vedvarende rødme og inflammatoriske responser med dokumenterte aktive ingredienser. Klinisk rosacea-behandling i Oslo.",
    lead:
      "Roer ned vedvarende rødme og inflammatoriske responser med dokumenterte aktive ingredienser. Vi behandler både synlige tegn og underliggende triggere.",
    paragraphs: [
      "Rosacea er en kronisk, men håndterbar tilstand. Med riktig kombinasjon av medisinsk hudpleie, LED-lys og beroligende protokoller kan vi redusere rødme, blusninger og inflammasjon betraktelig.",
      "Vi kartlegger triggerne dine – fra kosthold og temperatur til produkter – og lager en plan som gir både umiddelbar lindring og langsiktig kontroll.",
    ],
    treatments: [
      { slug: "led-lysbehandling", title: "LED-lysbehandling" },
      { slug: "kjemisk-peeling", title: "Beroligende kjemisk peeling" },
      { slug: "mesoterapi", title: "Mesoterapi" },
      { slug: "hydrafacial", title: "Hydrafacial for rosacea" },
      { slug: "beroligende-ansiktsbehandling", title: "Anti-inflammatorisk protokoll" },
      { slug: "hudbarriere", title: "Hudbarrierestyrking" },
    ],
    faq: [
      { q: "Kan rosacea kureres?", a: "Rosacea kan ikke kureres helt, men kan kontrolleres svært godt med riktig behandlingsplan." },
      { q: "Hvor lenge varer effekten?", a: "Vedlikeholdsbehandlinger anbefales hver 6–8 uke for stabil hud." },
    ],
  },
  hudbarriere: {
    slug: "hudbarriere",
    eyebrow: "Hudutfordring",
    h1: "Reparasjon av hudbarriere",
    metaTitle: "Hudbarriere-reparasjon Oslo | Klinisk styrking – Medskinby",
    metaDescription:
      "Gjenoppbygger og forsterker hudens forsvar – nøkkelen til langvarig hudhelse. Klinisk hudbarriere-behandling i Oslo.",
    lead:
      "Gjenoppbygger og forsterker hudens forsvar – nøkkelen til langvarig hudhelse. En sterk barriere er forutsetningen for hud som tåler, fungerer og ser frisk ut.",
    paragraphs: [
      "Hudbarrieren er hudens skall mot omverdenen. Når den svikter får vi tørrhet, ru hud, stikking, rødme og økt følsomhet for produkter. De fleste hudtilstander forverres av svekket barriere.",
      "Vi bygger barrieren tilbake med en kombinasjon av ekstern (produkter, peelinger, LED) og intern (skinboosters, polynukleotider, mesoterapi) tilnærming. Resultatet er hud som fungerer som den skal.",
    ],
    treatments: [
      { slug: "mesoterapi", title: "Mesoterapi" },
      { slug: "skinbooster", title: "Skinboosters" },
      { slug: "polynukleotider", title: "Polynukleotider" },
      { slug: "hydrafacial", title: "Hydrafacial" },
      { slug: "led-lysbehandling", title: "LED-lysbehandling" },
      { slug: "beroligende-ansiktsbehandling", title: "Reparative ansiktsbehandlinger" },
    ],
    faq: [
      { q: "Hvor lang tid tar det å reparere barrieren?", a: "Hudbarrieren snur seg på 4–8 uker med riktige rutiner og behandlinger." },
    ],
  },
  "hormonell-ubalanse": {
    slug: "hormonell-ubalanse",
    eyebrow: "Hudutfordring",
    h1: "Hormonell akne & hudbehandling",
    metaTitle: "Hormonell akne Oslo | Helhetlig hudbehandling – Medskinby",
    metaDescription:
      "Helhetlig kartlegging og behandling av hud påvirket av sykluser, stress og hormonelle skift. Klinisk hudklinikk på Frogner.",
    lead:
      "Helhetlig kartlegging og behandling av hud påvirket av sykluser, stress og hormonelle skift. Vi behandler huden i kontekst – ikke isolert.",
    paragraphs: [
      "Hormonell akne følger ofte mønstre: kjeve- og hakeområdet, syklus-relaterte utbrudd, dyptliggende cyster. Det krever en annen strategi enn standard akneprotokoller.",
      "Vi kombinerer klinisk behandling med livsstil og produkt-veiledning, og samarbeider gjerne med lege ved behov. Målet er stabil hud gjennom hele syklusen.",
    ],
    treatments: [
      { slug: "kjemisk-peeling", title: "Kjemisk peeling" },
      { slug: "microneedling", title: "Microneedling" },
      { slug: "mesoterapi", title: "Mesoterapi" },
      { slug: "led-lysbehandling", title: "LED-lysbehandling" },
      { slug: "dyprens", title: "Dyprens" },
      { slug: "konsultasjon", title: "Individuelt hudprogram" },
    ],
    faq: [
      { q: "Må jeg ta blodprøver?", a: "Ikke alltid – men ved mistanke om underliggende hormonell ubalanse henviser vi til lege." },
    ],
  },
  "anti-age-hudfornyelse": {
    slug: "anti-age-hudfornyelse",
    eyebrow: "Hudutfordring",
    h1: "Anti-age & hudfornyelse i Oslo",
    metaTitle: "Anti-age behandling Oslo | Hudfornyelse – Medskinby",
    metaDescription:
      "Preventive og regenererende protokoller for fasthet, glød og fornyet hudstruktur. Anti-age hudklinikk på Frogner, Oslo.",
    lead:
      "Preventive og regenererende protokoller for fasthet, glød og fornyet hudstruktur. Vi tror på naturlig fornyelse – ikke forandring.",
    paragraphs: [
      "Anti-age handler ikke om å bekjempe alder, men om å beholde hudens egen kvalitet over tid. Vi kombinerer kollagenstimulerende behandlinger med biostimulatorer og hudkvalitets-injeksjoner.",
      "Behandlingsplanen er alltid individuell og bygges rundt dine prioriteringer – glød, fasthet, finheter eller hudstruktur. Resultatene er naturlige og bygger seg gradvis.",
    ],
    treatments: [
      { slug: "dermapen", title: "Dermapen" },
      { slug: "microneedling", title: "Microneedling" },
      { slug: "polynukleotider", title: "Polynukleotider" },
      { slug: "mesoterapi", title: "Mesoterapi" },
      { slug: "skinbooster", title: "Skinboosters" },
      { slug: "kjemisk-peeling", title: "Kjemisk peeling" },
      { slug: "led-lysbehandling", title: "LED-lysbehandling" },
      { slug: "subcision", title: "Subcision (arr & linjer)" },
      { slug: "profhilo", title: "Profhilo" },
      { slug: "hifu", title: "HIFU" },
    ],
    faq: [
      { q: "Når bør jeg starte med anti-age?", a: "Forebyggende behandlinger gir best effekt fra slutten av 20-årene. Det er aldri for sent å starte." },
    ],
  },
};

export const PILLAR_LIST = Object.values(PILLARS).map((p) => ({
  slug: p.slug,
  title: p.h1.replace(" i Oslo", "").replace(" Oslo", ""),
  short: p.eyebrow,
}));
